import React from "react";

const SvgArrowDownSorting = props => (
  <svg width={10} height={7} viewBox="0 0 10 7" className={`svg ${props.className}`}>
    <path fill="currentColor" d="M5 3.728L1.852.5.5 1.886 5 6.5l4.5-4.614L8.148.5z" />
  </svg>
)

export default SvgArrowDownSorting
